var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }